import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 获取主单号列表
export function queryMAWBDetails(data) {
  return request({
    url: URL.booking.mawbDetail.queryMAWBDetails,
    method: 'post',
    data
  })
}

// 验证主单号列表是否可用
export function validateMAWBNums(data) {
  return request({
    url: URL.booking.mawbDetail.validateMAWBNums,
    method: 'post',
    data
  })
}

// 更新主单号
export function updateMAWBDetail(data, params) {
  return request({
    url: URL.booking.mawbDetail.updateMAWBDetail,
    method: 'put',
    data,
    params
  })
}

// 批量更新主单
export function batchUpdateMAWBDetail(data) {
  return request({
    url: URL.booking.mawbDetail.batchUpdateMAWBDetail,
    method: 'post',
    data
  })
}

// 批量分配主单
export function batchAssignmentMAWBDetail(data) {
  return request({
    url: URL.booking.mawbDetail.batchAssignmentMAWBDetail,
    method: 'post',
    data
  })
}

// 解除绑定
export function detchMAWBDetail(params) {
  return request({
    url: URL.booking.mawbDetail.detchMAWBDetail,
    method: 'put',
    params
  })
}

// 批量解除绑定
export function batchDetchMAWBDetail(data) {
  return request({
    url: URL.booking.mawbDetail.batchDetchMAWBDetail,
    method: 'post',
    data
  })
}

export function queryMAWBStatistics(data, params) {
  return request({
    url: URL.booking.mawbDetail.queryMAWBStatistics,
    method: 'post',
    data,
    params
  })
}
